
import { Component, Vue } from 'vue-property-decorator'

import { RallyRoundButton } from '@/lib/models/RallyRoundButton'
import { RallyRound as RallyRoundModel } from '@/lib/models/RallyRound'
import BacButton from '@/components/BacButton.vue'
import BacModal from '@/components/BacModal.vue'
import BacInput from '@/components/BacInput.vue'
import { Rally } from '@/lib/models/Rally'
import { Http } from '@/lib/utils/Http'
import UIkit from 'uikit'

@Component({
  components: {
    BacButton,
    BacModal,
    BacInput
  }
})
export default class BaseButtons extends Vue {
  headers = [
    { text: 'Name', value: 'name', width: 30 },
    { text: 'Link', value: 'link', width: 80 },
    { text: 'Sortierung', value: 'sort', width: 20 },
    { text: 'Bild', value: 'image', width: 80 },
    { text: 'Target', value: 'target', width: 40 },
    { text: 'Berechtigung', value: 'permission', width: 40 },
    { text: 'Aktionen', value: 'actions', width: 30 }
  ];

  rallyRoundButtons: RallyRoundButton[] = []
  rallyRounds: RallyRoundModel[] = []
  rallies: Rally[] = []
  buttonImages: { name: string; link: string }[] = []

  selectedButton = new RallyRoundButton()
  selectedImage = '1.png'
  isAddingButton = false
  isDeletingButton = false

  get items () {
    return this.rallyRoundButtons.sort((a, b) => {
      return a.sort - b.sort
    })
  }

  mounted () {
    this.loadRallyRoundButtons()
    this.loadRallyRounds()
    this.loadRallies()
    this.loadButtonImages()
  }

  getButtonLinkFromName (name: string) {
    return this.buttonImages.find(image => image.name === name)
  }

  async loadButtonImages () {
    this.buttonImages = []
    const buttonFilenames = (await require.context('@/assets/img/buttons/')).keys()
    buttonFilenames.map(async rawName => {
      const name = rawName.split('/')[1]
      const link = (await import(`@/assets/img/buttons/${name}`)).default
      this.buttonImages.push({ name, link })
    })
  }

  async saveButton () {
    if (this.isAddingButton) {
      return
    }
    this.isAddingButton = true
    const method = this.selectedButton.id ? 'PUT' : 'POST'
    if (!this.selectedButton.rallyRoundId) {
      this.selectedButton.rallyRoundId = parseInt(this.$route.params.rallyRoundId)
    }
    this.selectedButton.image = this.selectedImage
    const apiRoute = this.selectedButton.id
      ? `/api/rally-round/${this.selectedButton.rallyRoundId}/button/${this.selectedButton.id}`
      : `/api/rally-round/${this.selectedButton.rallyRoundId}/button`

    const res = await Http.request(apiRoute, {
      method,
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(this.selectedButton)
    })
    if (res.status !== 200) {
      UIkit.notification({
        message: 'Es ist ein Fehler aufgetreten, bitte überprüfe deine Eingaben!',
        status: 'success',
        timeout: 5000,
        pos: 'bottom-center'
      })
    } else {
      UIkit.notification({
        message: 'Button gespeichert!',
        status: 'success',
        timeout: 5000,
        pos: 'bottom-center'
      })
      UIkit.modal('#add-button-modal').hide()
    }
    setTimeout(() => { this.isAddingButton = false }, 1000)
    this.selectedButton = new RallyRoundButton()
    this.selectedImage = '1.png'
    this.loadRallyRoundButtons()
  }

  async loadRallies () {
    this.rallies = await Rally.getAll({})
  }

  async loadRallyRounds () {
    this.rallyRounds = await RallyRoundModel.getAll({})
  }

  async loadRallyRoundButtons () {
    this.rallyRoundButtons = await RallyRoundButton.getAll({ params: [this.$route.params.rallyRoundId, 'buttons'] })
  }

  getRallyFromId (id: number): Rally {
    const nullRally = new Rally()
    nullRally.name = '-'
    if (!id) {
      return nullRally
    }
    const foundRally = this.rallies.find(rally => {
      return rally.id === id
    })
    if (!foundRally) {
      return nullRally
    }
    return foundRally
  }

  async deleteButton () {
    if (this.isDeletingButton) {
      return
    }
    this.isDeletingButton = true
    const res = await Http.request(`/api/rally-round/${this.$route.params.rallyRoundId}/button/${this.selectedButton.id}`, {
      method: 'DELETE'
    })

    if (res.status !== 200) {
      UIkit.notification({
        message: 'Es ist ein Fehler aufgetreten!',
        status: 'success',
        timeout: 5000,
        pos: 'bottom-center'
      })
    } else {
      UIkit.notification({
        message: 'Button gelöscht!',
        status: 'success',
        timeout: 5000,
        pos: 'bottom-center'
      })
      UIkit.modal('#delete-button-modal').hide()
    }

    setTimeout(() => { this.isDeletingButton = false }, 1000)
    this.selectedButton = new RallyRoundButton()
    this.selectedImage = '1.png'
    this.loadRallyRoundButtons()
  }
}
